import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';

import './sass/index.scss';
import './styles/global.scss';

ReactDOM.render(<App />, document.getElementById('root'));
